/**
 * ada-dialog.js — DEV-14567
 * Manages accessible dialog lifecycle: focus trap, Esc to close, focus return.
 *
 * Usage:
 *   var dialog = new ADADialog({
 *     dialogEl: document.getElementById('my-dialog'),
 *     triggerEl: document.querySelector('[data-open-my-dialog]'),
 *     onClose: function() { ... } // optional callback
 *   });
 *   dialog.open();
 *   dialog.close();
 */
(function(global) {
  'use strict';

  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    'details > summary'
  ].join(',');

  function ADADialog(opts) {
    this.dialogEl = opts.dialogEl;
    this.triggerEl = opts.triggerEl || null;
    this.onClose = opts.onClose || null;
    this._handleKeydown = this._handleKeydown.bind(this);
  }

  ADADialog.prototype.open = function() {
    var self = this;
    this.dialogEl.removeAttribute('hidden');
    this.dialogEl.setAttribute('aria-hidden', 'false');
    // Hide all body siblings so SR cannot reach background content.
    // Targeting siblings (not body) keeps the dialog itself in the AT tree.
    Array.from(document.body.children).forEach(function(el) {
      if (el !== self.dialogEl) el.setAttribute('aria-hidden', 'true');
    });
    document.addEventListener('keydown', this._handleKeydown);
    // Focus first focusable element inside dialog
    var focusable = this.dialogEl.querySelectorAll(FOCUSABLE);
    if (focusable.length) focusable[0].focus();
    else this.dialogEl.focus();
  };

  ADADialog.prototype.close = function() {
    this.dialogEl.setAttribute('hidden', '');
    this.dialogEl.setAttribute('aria-hidden', 'true');
    // Restore all siblings (blanket remove — pre-existing aria-hidden is edge case
    // not present in this theme's popups).
    Array.from(document.body.children).forEach(function(el) {
      el.removeAttribute('aria-hidden');
    });
    document.removeEventListener('keydown', this._handleKeydown);
    // Return focus to the element that opened the dialog
    if (this.triggerEl) this.triggerEl.focus();
    if (this.onClose) this.onClose();
  };

  ADADialog.prototype._handleKeydown = function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      this.close();
      return;
    }
    if (e.key !== 'Tab') return;

    var focusable = Array.prototype.slice.call(
      this.dialogEl.querySelectorAll(FOCUSABLE)
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      // Shift+Tab — if on first, wrap to last
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      // Tab — if on last, wrap to first
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  global.ADADialog = ADADialog;
})(window);
